import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {

  constructor(private http: HttpClient) { }

  SendFeedback(userId: string, message: string){
    return this.http.post(environment.apiUrl + 'Feedback', {
      UserId: userId,
      UserMessage: message
    } );
  }
}
